import themed from '../../../themer/themed';
import { IStyledHeaderProps } from '../IStyledHeaderProps';

export const getBackgroundColor = themed<IStyledHeaderProps>(
	({ color }, { inverted }) =>
		inverted ? color.highlight : color.background.light,
);
